module.exports = __webpack_public_path__ + "img/form-bg-red.dec76087.png";